import globalScope from 'core/globalScope';

var grecaptcha;
if (globalScope.window.grecaptcha) {
  grecaptcha = globalScope.window.grecaptcha;
} else {
  console.warn('Pas de recaptcha sur la page');
  grecaptcha = function() {};
  grecaptcha.ready = function() {};
  grecaptcha.execute = function() {};
}

export default grecaptcha;
